<template>
    <div class="home">
          <!--  <img alt="Vue logo" src="../assets/images/hehe.png">
            <HelloWorld msg="Witamy w aplikacji EyeCounter"/>-->
        <h2 class="title">{{$store.getters.user.username}} - {{$t(`roles.${this.$store.getters.role}`)}}</h2>
        <Message :message="message" :type="type" v-if="message"></Message>
        <Preloader v-if="!loaded && singular !== -1"></Preloader>
        <div class="singular-container" v-if="singular === 1 && loaded && singular !== -1">
            <div class="dashboard-card" v-if="loaded">
                <SingularChart :dataCollection="chartData" :key="key" :salon="salons[0]"></SingularChart>
            </div>
            <div class="dashboard-card map" v-if="loaded">
                <div class="top">{{$t('home.localization')}}</div>
                <Map :center="center" :key="componentKey" :salons="salons" :zoom="zoom"></Map>
            </div>
            <div class="dashboard-card" v-if="loaded">
                <MetricsLine :image="image" :key="key"></MetricsLine>
            </div>
            <div class="dashboard-card" v-if="loaded">
                <WeatherCard :key="key" :salon="salons[0]" :weather="weather"></WeatherCard>
            </div>
        </div>
        <div v-if="singular === 0 && loaded && singular !== -1">
            <div class="multiple-container" v-if="loaded">
                <div class="chart-container-big">
                    <div class="top">{{$t('home.entries')}}</div>
                    <div class="chart-container">
                        <bar-chart :chart-data="chartData" :height="chartHeight" :key="key"
                                   :options="style"></bar-chart>
                    </div>
                </div>
                <div class="map-big" v-if="loaded">
                    <div class="top">{{$t('home.localization')}}</div>
                    <Map :center="center" :key="componentKey" :salons="salons" :zoom="zoom" :bounds="bounds"></Map>
                </div>
            </div>
        </div>
        <div class="devices" v-if="loaded && devices.length > 0 && singular !== -1">
            <DevicesCard :devices="devices" :key="key"></DevicesCard>
        </div>
        <div class="fallback" v-if="singular === -1"><h2 class="title">{{$t('home.no-salons')}}</h2>
        </div>

    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';
import MetricsLine from '@/components/MetricsLine';
import Map from '@/components/maps/Map.vue';
import SingularChart from '@/components/charts/SingularChart';
import WeatherCard from '@/components/weather/WeatherCard';
import DevicesCard from '@/components/devices/DevicesCard';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import BarChart from '@/components/charts/BarChart.js';
import Message from '@/components/helpers/Message';
import {AccessForbidden, ImageNotFoundError, ServerError} from '@/api/user/erros';
import Preloader from '@/components/helpers/Preloader';

const DataRepository = RepositoryFactory.get('data');
const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'home',
  data() {
    return {
      stuff: false,
      // devices: [],
      weather: {},
      center: {},
      loaded: false,
      message: '',
      type: 'info',
      zoom: 12,
      componentKey: 0,
      counters: {},
      countersYesterday: {},
      salons: [],
      image: require('@/assets/images/salons/placeholder.jpg'),
      key: 0,
      bounds: [],
    };
  },
  components: {
    Preloader,
    Message,
    DevicesCard,
    WeatherCard,
    SingularChart,
    MetricsLine,
    HelloWorld,
    Map,
    BarChart,
  },
  watch: {
    groupID(newValue, oldValue) {
      this.loaded = false;
      this.key += 1;
      this.getData(newValue);
    },
  },
  mounted() {
    this.getData(this.$store.getters.selectedGroup.id);
  },
  computed: {
    groupID() {
      return this.$store.getters.selectedGroup.id;
    },
    chartHeight() {
      if (this.chartData.labels.length * 75 > 320) {
        return this.chartData.labels.length * 75;
      }
      return 320;
    },
    styleObject() {
      return this.$store.getters.cssConfig;
    },
    singular() {
      if (this.$store.getters.salons === undefined || this.$store.getters.salons.length === 0) {
        return -1;
      }
      if (this.$store.getters.salons.length > 1) {
        return 0;
      }
      return 1;
    },
    devices() {
      const devices = [];
      this.salons.forEach((v) => {
        v.sensors.forEach((d) => {
          devices.push(d);
        });
      });

      return devices;
    },
    style() {
      const height = this.chartData.labels.length * 20;
      return {
        maintainAspectRatio: false,
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
        height,
      };
    },
    chartData() {
      const datacollection = {
        labels: [],
        datasets: [
          {
            label: this.$t('general.entries'),
            backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
            data: [],
          }, {
            label: this.$t('general.exits'),
            backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
            data: [],
          },
        ],
      };
      if (!this.singular) {
        for (const elem in this.counters) {
          datacollection.labels.push(elem);
          datacollection.datasets[0].data.push(this.counters[elem].inSum);
          datacollection.datasets[1].data.push(this.counters[elem].outSum);
        }
      } else {
        datacollection.labels = [this.$t('general.today'), this.$t('general.yesterday')];
        for (const elem in this.counters) {
          datacollection.datasets[0].data.push(this.counters[elem].inSum);
          datacollection.datasets[1].data.push(this.counters[elem].outSum);
        }
        for (const elem in this.countersYesterday) {
          datacollection.datasets[0].data.push(this.countersYesterday[elem].inSum);
          datacollection.datasets[1].data.push(this.countersYesterday[elem].outSum);
        }
      }

      return datacollection;
    },
  },
  methods: {
    async getData(groupID) {
      this.$store.commit('set_api_call', true);
      const { token } = this.$store.getters;
      SalonsRepository.getShopsGroup(token, groupID).then((response) => {
        if (response.length === 1) {
          this.singular = 1;

          SalonsRepository.getDashboardSingular(
            token,
            response[0].id,
          )
            .then((response) => {
              this.devices = response.shops[0].sensors;
              this.weather = response.weather;
              this.center = {
                lat: response.shops[0].latitude,
                lng: response.shops[0].longitude,
              };
              this.counters = response.counters;
              this.countersYesterday = response.countersYesterday;
              this.salons = response.shops;
              SalonsRepository.getShopImage(this.$store.getters.token, this.salonId)
                .then((resp) => {
                  this.image = resp.image;
                })
                .catch((error) => {
                  if (error instanceof ImageNotFoundError) {
                    this.image = require('@/assets/images/salons/placeholder.jpg');
                  }
                });
              this.$store.commit('set_api_call', false);
              this.loaded = true;
              this.message = '';
              this.forceRerender();
            }).catch(async (error) => {
              if (error instanceof ServerError) {
                this.message = this.$t('errors.internalServerError');
                this.type = 'error';
              }
              if (error instanceof AccessForbidden) {
                this.message = this.$t('errors.accessForbidden');
                this.type = 'error';
                await this.$store.dispatch('logout');
                this.$router.push('/login');
              }
              this.$store.commit('set_api_call', false);
            });
        } else {
          this.singular = 0;
          SalonsRepository.getDashboardMultiple(token,
            this.$store.getters.selectedGroup.id)
            .then((response) => {
              this.message = '';
              this.counters = response.counters;
              this.salons = response.shops;
              this.getZoomLevel(
                Math.abs(this.getMinY(this.salons) - this.getMaxY(this.salons)),
                Math.abs(this.getMinX(this.salons) - this.getMaxX(this.salons)),
              );
              this.bounds = [
                [this.getMaxY(response.shops), this.getMinX(response.shops)],
                [this.getMinY(response.shops), this.getMaxX(response.shops)],
              ];
              this.$store.commit('set_api_call', false);
              this.stuff = true;
              this.loaded = true;
            }).catch(async (error) => {
              if (error instanceof ServerError) {
                this.message = this.$t('errors.internalServerError');
                this.type = 'error';
              }
              if (error instanceof AccessForbidden) {
                this.message = this.$t('errors.accessForbidden');
                this.type = 'error';
                await this.$store.dispatch('logout');
                this.$router.push('/login');
              }
              this.$store.commit('set_api_call', false);
            });
        }
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    getMinY(salons) {
      return salons.reduce((min, p) => (p.latitude < min ? p.latitude : min), salons[0].latitude);
    },
    getMaxY(salons) {
      return salons.reduce((max, p) => (p.latitude > max ? p.latitude : max), salons[0].latitude);
    },
    getMinX(salons) {
      return salons.reduce((min, p) => (p.longitude < min ? p.longitude : min), salons[0].longitude);
    },
    getMaxX(salons) {
      return salons.reduce((max, p) => (p.longitude > max ? p.longitude : max), salons[0].longitude);
    },
    getZoomLevel(deltaLat, deltaLong) {
      this.center = {
        lat: deltaLat / 2,
        lng: deltaLong / 2,
      };
      if (deltaLat === 0 && deltaLong === 0) {
        this.zoom = 11;
      } else {
        const zoomY = Math.floor(360 / deltaLong);
        const zoomX = Math.floor(360 / deltaLat);
        let zoom = Math.min(zoomX, zoomY) - 2;
        if (zoom < 0) {
          zoom = 0;
        }
        this.zoom = zoom;
      }

      // this.zoom = 0;
    },
  },
};
</script>
<style lang="scss">
    .home {
        width: 100%;
    }

    img {
        display: block;
    }

    .singular-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .dashboard-card {
            width: 49%;
            background: white;
            border-radius: 5px;
            max-height: 382px;
            opacity: 0.8;
            box-sizing: border-box;
            margin: 15px 0;
            @include media('<1645px') {
                width: 100%;
            }
            @include media('<665px') {
                max-height: unset;
            }
            /*&:nth-child(2n) {*/
            /*    margin-right: 15px;*/
            /*}*/

            /*&:nth-child(2n+1) {*/
            /*    margin-left: 15px;*/
            /*}*/
        }
    }


    .user-dashboard {
        display: flex;
        flex-wrap: wrap;
    }

    .devices {
        background: white;
        border-radius: 5px;
        width: 100%;
    }

    .map {
        height: 382px;

        .map-container {
            width: 100%;
            height: 299px;
        }

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 30px;
            border-bottom: 1px solid $border-gray;
            /* color: #878a94; */
            font-size: rem(18px);
            font-weight: 800;
            text-transform: uppercase;
            text-align: left;
            padding: 29px 26px;
        }
    }

    .devices {
        width: 100%;
        margin: 0 auto;
        margin-top: 30px;
        @include media('<1850px') {
            overflow-x: scroll;
        }
    }

    .map-big {
        background-color: white;
        height: 675px;
        margin: 0 auto;
        width: 100%;
        position: relative;
        z-index: 0;
        margin-top: 30px;

        .map-container {
            width: 100%;
            height: calc(675px - 83px);
        }

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 30px;
            border-bottom: 1px solid $border-gray;
            // color: $baseTextColor;
            font-size: rem(18px);
            font-weight: 800;
            text-transform: uppercase;
            text-align: left;
            padding: 29px 26px;
        }
    }

    .chart-container-big {
        /*width: 100%;*/
        height: calc(675px - 83px);
        background: white;
        border-radius: 5px;
        /*width: calc(724px * 2);*/
        margin: 0 auto;
        box-sizing: border-box;
        width: 100%;

        .chart-container {
            padding: 40px;
            max-height: 400px;
            overflow-y: scroll;
            padding-left: 0;

        }

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 30px;
            border-bottom: 1px solid $border-gray;
            // color: $baseTextColor;
            font-size: rem(18px);
            font-weight: 800;
            text-transform: uppercase;
            text-align: left;
            padding: 29px 26px;
        }
    }

    .multiple-container {
        width: 100%;
    }
</style>
